import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'vr-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class ForgotPasswordComponent {

  email: string;

  constructor(
    private router: Router,
    private i18n: I18n,
    private http: HttpClient,
    private matSnackBar: MatSnackBar
  ) { }

  /**
   * Send request to reset password
   */
  send() {
    this.http.post(environment.API_PATH + 'auth/send-lost-password-email', {email: this.email}, {withCredentials: true}).subscribe(response => {
      if (response['success']) {
        this.matSnackBar.open(this.i18n({value: 'An email was send to your address. Pleas check your email address.', id: 'EmailSendLostPassword'}), '', {duration: 5000} as MatSnackBarConfig);
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/forgot-password/forgot-password.component.ts